/* custom-collection-tilt.js
   - Randomizes tilt and small scale for product card images.
   - Targets common Dawn selectors; safe to include site-wide.
   - Re-randomizes on resize and every N seconds (configurable).
*/

(function () {
  // Configuration
  const MIN_DEG = -6;     // minimum tilt degrees
  const MAX_DEG = 6;      // maximum tilt degrees
  const MIN_SCALE = 0.92; // smallest image scale
  const MAX_SCALE = 0.98; // largest image scale
  const MOBILE_MAX_SCALE = 0.98;
  const RE_RANDOMIZE_MS = 12000; // set to falsey (0/null) to disable periodic re-randomize

  // Utility: random number between min and max
  function randBetween(min, max) {
    return Math.random() * (max - min) + min;
  }

  // Apply random tilt to an element (wrapper) and its mobile fallback variable
  function applyTiltTo(wrapperEl) {
    const deg = randBetween(MIN_DEG, MAX_DEG);
    const scale = randBetween(MIN_SCALE, MAX_SCALE);
    wrapperEl.style.setProperty('--tilt-rot', deg.toFixed(2) + 'deg');
    wrapperEl.style.setProperty('--tilt-scale', scale.toFixed(3));
    // smaller tilt/scale on mobile
    wrapperEl.style.setProperty('--tilt-scale-mobile', Math.min(scale, MOBILE_MAX_SCALE).toFixed(3));
  }

  // Find product media wrappers
  function findMediaWrappers() {
    // selectors cover Dawn common variants; can be extended if needed
    const selectors = [
      '.collection__grid .product-card__media',
      '.collection__grid .card__media',
      '.product-card__media',
      '.card__media',
      '.product-card__image',
      '.card__image'
    ];
    const nodeList = document.querySelectorAll(selectors.join(','));
    return Array.prototype.slice.call(nodeList);
  }

  // (Re)initialize tilt effect
  function initTilt() {
    const wrappers = findMediaWrappers();

    if (!wrappers.length) return;

    wrappers.forEach((w) => {
      // only apply once unless re-randomizing
      applyTiltTo(w);
    });
  }

  // Throttle resize handling
  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initTilt();
    }, 220);
  }

  // When DOM is ready (or on turbolinks/section load), initialize
  function readyInit() {
    initTilt();

    // Re-randomize periodically if desired
    if (RE_RANDOMIZE_MS) {
      setInterval(initTilt, RE_RANDOMIZE_MS);
    }

    // Re-randomize on resize
    window.addEventListener('resize', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', readyInit);
  } else {
    readyInit();
  }

  // If your theme uses section rendering / async loading, also listen for Shopify events
  // so newly-injected collection blocks get the tilt applied. Dawn fires 'shopify:section:load'
  window.addEventListener('shopify:section:load', function () { initTilt(); });
  window.addEventListener('shopify:section:reorder', function () { initTilt(); });
  window.addEventListener('shopify:section:select', function () { initTilt(); });

})();
